// Optimistic credential verify toggle. Mirrors useMarkVerify: optimistic set +
// revert-on-error, hitting the per-credential verify endpoint
// (POST /credentials/athlete/{userId}/{id}/verify) which returns the updated
// row. Staff/partner only — the caller gates rendering on perms.canVerify.
import { useState } from 'react';
import axios from 'axios';

export default function useCredentialVerify({ userId, apiUrl, getConfig, setCredentials }) {
  const [busyId, setBusyId] = useState(null);

  const toggleVerify = async (c) => {
    const next = !c.verified;
    setBusyId(c.id);
    setCredentials(list => list.map(x => (x.id === c.id ? { ...x, verified: next } : x)));
    try {
      const res = await axios.post(
        `${apiUrl}/credentials/athlete/${userId}/${c.id}/verify`, {}, getConfig());
      setCredentials(list => list.map(x => (x.id === c.id ? { ...x, ...res.data } : x)));
    } catch {
      // revert
      setCredentials(list => list.map(x => (x.id === c.id ? { ...x, verified: c.verified } : x)));
    } finally {
      setBusyId(null);
    }
  };

  return { toggleVerify, busyId };
}
